import {
  AggregateItemType,
  AggregateTypes,
} from '@components/Studio/QueryCreationTwo/Props/modals/AggregatesModal/interfaces/Aggregates.interface';
import { PROPERTY_TYPE_URIS } from 'utils/Studio/properties';

/**
 * Returns the property type URI for aggregate outputs based on the input property type URI and aggregate type.
 *
 * @param {string} propertyTypeUri - The URI of the property type.
 * @param {AggregateItemType} aggrType - The type of aggregation being performed.
 * @returns {string} - The appropriate property type URI for the aggregate output.
 */
export const getPropertyTypeUriForAggregateOutputs = (
  propertyTypeUri: string,
  aggrType: AggregateItemType
): string => {
  switch (propertyTypeUri) {
    case PROPERTY_TYPE_URIS.dateTime:
    case PROPERTY_TYPE_URIS.date:
    case PROPERTY_TYPE_URIS.bool:
      if (aggrType === AggregateTypes.COUNT) {
        return PROPERTY_TYPE_URIS.number;
      } else {
        return propertyTypeUri;
      }

    case PROPERTY_TYPE_URIS.str:
      if (aggrType === AggregateTypes.COUNT || aggrType === AggregateTypes.DISTINCTCOUNT) {
        return PROPERTY_TYPE_URIS.number;
      } else {
        return propertyTypeUri;
      }

    default:
      return PROPERTY_TYPE_URIS.number;
  }
};
